import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import * as Sentry from "@sentry/react";
import { HOST } from "Constant/Constant";
import { getQueryString } from "Constant/utils";
import { getAdminFees } from "store/reducer/get-admin-fee";

export const adminFeeApi = createApi({
  reducerPath: "adminFeeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${HOST}`,
  }),

  endpoints: (builder) => ({
    adminFee: builder.mutation({
      query: (getQueryParams) =>
      {
        return {
          url: `/get-admin-fee${getQueryString(getQueryParams)}`,
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const response = await queryFulfilled;
          dispatch(
            getAdminFees({
              data: {summaryReport: response?.data?.summaryReport ?? []},
            })
          );
        } catch (error) {
          console.error(">>>>>getAdminFees error", error);
          Sentry.addBreadcrumb({ category: "api", message: "getAdminFees mutation failed", level: "error", data: { error } });
          dispatch(getAdminFees({ data: [] }));
        }
      },
    }),

    invoiceDownload: builder.mutation({
      query: (invoiceInfo) =>
      {
        return {
          url: '/send-admin-fee-file',
          method: "POST",
          body: invoiceInfo,
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      },
    }),

    adminFeeSummary: builder.mutation({
      query: (params) => ({
        url: `/admin-fee-graph`,
        method: "POST",
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: params,
      }),
    }),

    totolSalesGraph: builder.mutation({
      query: (params) => ({
        url: `/total-sales-graph`,
        method: "POST",
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: params,
      }),
    }),

    dailyTransactionSummary: builder.mutation({
      query: (params) => ({
        url: `/daily-transaction-summary`,
        method: "POST",
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: params,
      }),
    }),
  }),
});

export const { useAdminFeeMutation, useInvoiceDownloadMutation, useAdminFeeSummaryMutation, useTotolSalesGraphMutation, useDailyTransactionSummaryMutation } = adminFeeApi;
